import Image from 'next/image';

import Text from '@/components/ui/Text';
import { ArticleDetail } from '@/lib/contentful/api/getArticle';

type Author = NonNullable<ArticleDetail['author']>;

const AuthorInfo = ({ author }: AuthorInfoProps) => (
  <div className="relative flex items-center pr-4">
    {author.photoUrl && (
      <Image
        src={author.photoUrl}
        alt={author.name}
        width={48}
        height={48}
        className="rounded-full object-cover mr-3"
      />
    )}
    <Text as="p" variant="paragraph" className="mb-0!">
      {author.name}
    </Text>
  </div>
);

export default AuthorInfo;

type AuthorInfoProps = {
  author: Author;
};
